var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleNumberFrame',{attrs:{"title":"# of routes","value":_vm.itemData}})
}
var staticRenderFns = []

export { render, staticRenderFns }